import { useEffect, useState } from 'react'

export function useTimedVisibility(key: string | null, durationMs: number): boolean {
    const [hidden, setHidden] = useState(false)

    useEffect(() => {
        if (!key) {
            setHidden(false)
            return undefined
        }
        setHidden(false)
        const id = window.setTimeout(() => setHidden(true), durationMs)
        return () => window.clearTimeout(id)
    }, [key, durationMs])

    return Boolean(key) && !hidden
}
